import { FC, PropsWithChildren } from 'react';
import './HeaderGroup.scss';

export const HeaderGroup: FC<PropsWithChildren> = ({ children }) => {
  return <div className="HeaderGroup">{children}</div>;
};
